"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _form = _interopRequireDefault(require("antd/lib/form"));

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

require("../activity.scss");

var _activities = require("../../../redux/activities/activities.types");

var _FroalaCustomUpload = _interopRequireDefault(require("../FroalaCustomUpload"));

var _ActivityItemLabel = _interopRequireDefault(require("../ActivityItemLabel"));

var _Util = require("../../util/Util");

var _ActivityFormContainer = require("../ActivityFormContainer");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const {
  Option
} = _select.default;
const itemStyle = {
  width: '100%',
  marginBottom: '10px',
  marginTop: '10px'
};

class ActivityDetailForm extends _react.Component {
  constructor() {
    super(...arguments);
    this.form = /*#__PURE__*/_react.default.createRef(); // Action Handlers

    this.onChange = (field, state) => {
      const {
        setActivity
      } = this.props;
      setActivity(state);
    };

    this.onIntroChange = intro => {
      this.onChange('intro', {
        intro: (0, _Util.updateCmsEditorBeforeSave)(intro)
      });
    }; // Custom Field Validators


    this.validateIntro = (rule, value) => {
      const {
        activity
      } = this.props;
      const {
        intro
      } = activity;

      try {
        if (intro.length === 0) {
          throw new Error('Introduction is required.');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    }; // This validator is a hotfix to resolve an issue where
    // navigating to another form step and back causes the
    // description field in the form to be undefined.


    this.validateDescription = (rule, value) => {
      const {
        activity
      } = this.props;
      const {
        description
      } = activity;

      try {
        if (description.length === 0) {
          throw new Error('Description is required.');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };

    this.validateTitle = (rule, value) => {
      const {
        activity
      } = this.props;
      const {
        title
      } = activity;

      try {
        if (title.length === 0) {
          throw new Error('Title is required.');
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    }; // Renderers


    this.renderType = value => {
      switch (value) {
        case 'quiz':
          return 'Quizzes';

        case 'category':
          return 'Break it down';

        case 'category no-answer':
          return 'Break it down (no answer)';

        case 'cyoa':
          return 'Call the shots';

        case 'fill in the blank':
          return 'Fill it in';

        case 'goals':
          return 'Goals';

        case 'ranking':
          return 'Sort it out';

        case 'screener':
          return 'Assessments';
      }
    };

    this.capitalize = s => {
      return s ? s.split(' ').map(word => word[0].toUpperCase() + word.substring(1)).join(' ') : s;
    };

    this.characterLimit = (s, limit) => {
      return s ? s.length < limit ? limit - s.length : 0 : 0;
    };
  }

  componentDidMount() {
    const {
      setStatus,
      loadCategories,
      loadTypes,
      setActiveForm
    } = this.props;
    setStatus(_ActivityFormContainer.ActivityFormStatus.PROCESS);
    setActiveForm(this.form.current);
    loadCategories();
    loadTypes();
  }

  componentDidUpdate() {
    const {
      setStatus,
      activity
    } = this.props;
    const {
      typeId,
      category,
      title,
      description,
      intro
    } = activity;

    if (typeId > -1 && category && title.length > 0 && description.length > 0 && intro.length > 0) {
      setStatus(_ActivityFormContainer.ActivityFormStatus.FINISH);
    }
  }

  render() {
    const {
      activity,
      categories,
      types,
      creative,
      editable
    } = this.props;
    const {
      title,
      description,
      prompt,
      intro
    } = activity;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-form"
    }, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "form",
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: "typeId",
      name: "typeId",
      label: /*#__PURE__*/_react.default.createElement(_ActivityItemLabel.default, {
        label: "Activity Type:",
        tooltip: "Type determines what kind of activity you will create."
      }),
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Type is required.'
      }],
      initialValue: activity.typeId
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      disabled: !creative && !editable,
      onChange: val => this.onChange('typeId', {
        typeId: val
      }),
      placeholder: "Type",
      style: {
        width: 220
      }
    }, types === null || types === void 0 ? void 0 : types.map(t => /*#__PURE__*/_react.default.createElement(Option, {
      key: t.id,
      value: t.id
    }, this.renderType(t.type))))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "category",
      name: "category",
      label: "Activity Category:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Category is required.'
      }],
      initialValue: activity.category
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      disabled: !creative && !editable,
      onChange: val => this.onChange('category', {
        category: val
      }),
      placeholder: "Category",
      style: {
        width: 180
      }
    }, categories === null || categories === void 0 ? void 0 : categories.map(cat => /*#__PURE__*/_react.default.createElement(Option, {
      key: cat.id,
      value: cat.id
    }, cat.category)))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "title",
      name: "title",
      label: "Title:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Title is required.',
        validator: this.validateTitle
      }],
      initialValue: title
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      spellCheck: true,
      disabled: !creative && !editable,
      placeholder: "Name the activity",
      maxLength: 200,
      defaultValue: title,
      onChange: e => this.onChange('title', {
        title: e.target.value
      })
    }), /*#__PURE__*/_react.default.createElement("span", null, "(", this.characterLimit(title, 200), ' ', "characters left.)"))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "description",
      name: "description",
      label: "Description:",
      style: itemStyle,
      rules: [{
        required: true,
        validator: this.validateDescription
      }]
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      spellCheck: true,
      disabled: !creative && !editable,
      placeholder: "Blurb shown on main list",
      maxLength: 400,
      defaultValue: description,
      onChange: e => this.onChange('description', {
        description: e.target.value
      })
    }), /*#__PURE__*/_react.default.createElement("span", null, "(", this.characterLimit(description, 400), ' ', "characters left.)"))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "prompt",
      name: "prompt",
      label: /*#__PURE__*/_react.default.createElement(_ActivityItemLabel.default, {
        label: "Prompt:",
        tooltip: "The text that appears on the screen with each question."
      }),
      style: itemStyle
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      spellCheck: true,
      disabled: !creative && !editable,
      placeholder: "Prompt to appear above questions",
      maxLength: 200,
      defaultValue: prompt,
      onChange: e => this.onChange('prompt', {
        prompt: e.target.value
      })
    }), /*#__PURE__*/_react.default.createElement("span", null, "(", this.characterLimit(prompt, 200), ' ', "characters left.)"))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "intro",
      name: "intro",
      label: "Introduction:",
      style: itemStyle,
      rules: [{
        required: true,
        validator: this.validateIntro
      }],
      valuePropName: "model",
      initialValue: intro
    }, /*#__PURE__*/_react.default.createElement(_FroalaCustomUpload.default, {
      disabled: !creative && !editable,
      onChange: this.onIntroChange
    }))));
  }

}

const mapStateToProps = state => {
  return {
    categories: selectors.getCategories(state),
    types: selectors.getTypes(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadCategories: () => dispatch(_activities.getActivityCategoriesAsync.request()),
    loadTypes: () => dispatch(_activities.getActivityTypesAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActivityDetailForm);

exports.default = _default;